<div class="router-outlet">
    <router-outlet></router-outlet>
    <ngx-loading-bar [color]="'#FE6431'" [height]="'4px'"></ngx-loading-bar>
</div>
<div class="small-screen">
    <app-small-screen></app-small-screen>
</div>
